import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CKEditor4 } from "ckeditor4-angular/ckeditor";
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { MultilangComponent } from 'src/app/hubadmin/multilang/multilang.component';

@Component({
  selector: 'app-create-content-and-learing',
  templateUrl: './create-content-and-learing.component.html',
  styleUrls: ['./create-content-and-learing.component.scss']
})
export class CreateContentAndLearingComponent implements OnInit {
  @Input() engagementId = "";
  @Output() engagementCreated: EventEmitter<boolean> = new EventEmitter;
  @Output() getEngagementId: EventEmitter<number> = new EventEmitter;
  @Output() getEngagementTypeId: EventEmitter<number> = new EventEmitter;
  @Output() whitelist_obj: EventEmitter<object> = new EventEmitter;
  @ViewChild(MultilangComponent,{ static: false }) multilangComponent!: MultilangComponent;

  editorConfig = {
    toolbarGroups: [
      { name: "clipboard", groups: ["clipboard", "undo"] },
      { name: "editing", groups: ["find", "selection", "spellchecker"] },
      { name: "links" },
      { name: "insert" },
      { name: "document", groups: ["mode", "document", "doctools"] },
      { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
      { name: "paragraph", groups: ["list", "indent", "blocks", "align"] },
      { name: "styles" },
      { name: "colors" },
    ],
    skin: "kama",
    resize_enabled: false,
    removePlugins: "elementspath,save,magicline",
    extraPlugins: "divarea,smiley,justify,indentblock,colordialog",
    colorButton_foreStyle: {
      element: "font",
      attributes: { color: "#(color)" },
    },
    height: 188,
    versionCheck : false,
    removeDialogTabs: "image:advanced;link:advanced",
    removeButtons: "Subscript,Superscript,Anchor,Source,Table",
    format_tags: "p;h1;h2;h3;pre;div",
  };

  fg: FormGroup
  optionFormGroup: FormGroup
  formGroup: FormGroup;
  engagementTypes: any;
  roleTypes:any = [];
  localData: any
  submitted:boolean = false
  date = new Date ();
  languages:any=[];
  modalTitle: string;
  selectedQuestionIndex: number | null = null;
  selectedOptionIndex:number | null = null;
  engagementDataOnEdit:any
  moduleName:string="engagement";
  questionId:any
  optionId:any;
  multiLangFields:any = [
    {
      name : "course_title_multilang",
      type: 'control',
      title:"course_title"
    },
    {
      name : "course_quiz",
      type: "array",
      title : "question and option"
    }
  ] 
  minDate: any;
  isUserwhitelisted : boolean = false;
  // formData : any


  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService,
    private modalService: NgbModal,
  ) {
    this.localData = JSON.parse(localStorage.getItem('engagementDetail'))
    const today = new Date();
    this.minDate = today.toISOString().split('T')[0]; 
  }
  ngOnInit() {
    this.form()
    this.getEngagementTypes();
    this.getRoleTypes();
    this.getLanguage()
    if(this.localData.is_edit == true){
      this.getEnagagementDataOnEdit()
      this.whitelist_obj.emit({wts_type : this.localData.whitelist_type ,zn_type : this.localData.zone_type})
    }
  }

  form(data?){
    this.formGroup = this.fb.group({
      'engagement_type': new FormControl(data ? data.engagement_type_id : "", [Validators.required]),
      'engagement_name': new FormControl(data ? data.engagement_title : "", [Validators.required]),
      'start_date': new FormControl(data ? data.start_date : "", [Validators.required]),
      'end_date': new FormControl(data ? data.end_date : "", [Validators.required]),
      'reward_type': new FormControl(data ? data.quiz_points_criteria : "", [Validators.required]),
      'content_and_learning_type': new FormControl(data ? data.course_type : "", [Validators.required]),
      'quiz_configured': new FormControl(data ? data.quiz_configured : "", [Validators.required]),
      'reward_points': new FormControl(data ? data.reward_points : "", []),
      'course_description': new FormControl(data ? data.course_description : "", [Validators.required]),
      'course_content': new FormControl(data ? data.course_content : "", []),
      'pre_expiry_date': new FormControl(data ? data.pre_expiry_date : "", [Validators.required]),
      'cource_content_english_video': new FormControl(data ? data.course_content : "", []),
      whitelist_type : new FormControl(data?data.whitelist_type:"",[Validators.required]),
      zone_type : new FormControl({ value: data ? data.zone_type :"", disabled: this.isUserwhitelisted ? true : false},[]),
      role_type : new FormControl(data?data.role_type:"",[Validators.required]),
      'questionsSet': this.fb.array([])
    });
    if(data){
      if (data.course_quiz) {
        data.course_quiz.forEach(questions => {
          this.addQuestions(questions);
        });
      }
    }else{
      this.addQuestions()
    }
  }

  get formData (){
    return this.formGroup.getRawValue()
  } 

  get f() {
    return this.formGroup.controls;
  }

  addQuestions(question?: any) {
    this.fg = this.fb.group({
      'question': new FormControl({value : question ? question.question : '' , disabled: this.isUserwhitelisted ? true : false} , []),
      'answer': new FormControl({value : question ? question.answer : '' , disabled: this.isUserwhitelisted ? true : false} , [Validators.required]),
      'point': new FormControl({value : question ? question.points : '' , disabled: this.isUserwhitelisted ? true : false} , [Validators.required , Validators.min(1)]),
      'options': this.fb.array([]),
    });
    (<FormArray>this.formGroup.get('questionsSet')).push(this.fg);
    let questionIndex = (<FormArray>this.formGroup.get('questionsSet')).length - 1;
    this.selectedQuestionIndex = questionIndex
    if (!question) {
      this.addOptions(questionIndex);
    }
    else {
      question.option.forEach(option => {
        this.addOptions(questionIndex, option);
      });
    }
  }
  deleteQuestion(index: number) {
    // console.log(this.engagementDataOnEdit.course_quiz[index].quiz_id);
    // if(this.localData.is_edit == true){
    //   this.questionId = this.engagementDataOnEdit.course_quiz[index].quiz_id
    //   this.deleteQuestionAndOption(this.questionId,1)
    // }
    (<FormArray>this.formGroup.get('questionsSet')).removeAt(index);
  }

  addOptions(questionIndex: number, data?: any,index?:number) {
    this.selectedOptionIndex = index
    if ((<FormArray>(<FormGroup>(<FormArray>this.formGroup.controls['questionsSet']).controls[questionIndex]).controls['options']).length == 4) {
      return
    }
    console.log('questionIndex', questionIndex, '-------', 'data', data);
    this.optionFormGroup = this.fb.group({
      'option': new FormControl({ value :data ? data.option : '' , disabled: this.isUserwhitelisted ? true : false}, []),
    });
    (<FormArray>(<FormGroup>(<FormArray>this.formGroup.controls['questionsSet'])
      .controls[questionIndex]).controls['options']).push(this.optionFormGroup);
  }
  deleteOptions(questionIndex: number, index: number) {
    console.log('questionIndex', questionIndex, '-------', 'index', index);
    (<FormArray>(<FormGroup>(<FormArray>this.formGroup.controls['questionsSet'])
    .controls[questionIndex]).controls['options']).removeAt(index);
    // if(this.localData.is_edit == true){
    //   this.optionId = this.engagementDataOnEdit.course_quiz[questionIndex].option[index].id
    //   this.deleteQuestionAndOption(this.optionId,2)
    // }
  }
 

  isQuizConfigured(e) {
    console.log(this.formGroup)
    console.log(e)
    if (e == 1) {
      this.formGroup.controls['reward_points'].clearValidators();
      this.formGroup.controls['reward_points'].setErrors(null);
      this.formGroup.controls["reward_type"].setValidators(Validators.required);
      this.fg.controls["question"].setValidators(Validators.required);
      this.fg.controls["point"].setValidators(Validators.required);
      this.fg.controls["answer"].setValidators(Validators.required);
      this.optionFormGroup.controls["option"].setValidators(Validators.required);
      this.optionFormGroup.updateValueAndValidity();

      if(this.engagementDataOnEdit){
        if (this.engagementDataOnEdit.course_quiz.length==0 ) {
          this.addQuestions();
        }
    }
    } else {
      this.formGroup.controls['reward_points'].setValidators(Validators.required);
      this.formGroup.controls["reward_type"].clearValidators();
      this.formGroup.controls["reward_type"].setErrors(null);  
      this.fg.controls["question"].clearValidators();
      this.fg.controls["question"].setErrors(null);
      this.fg.controls["point"].clearValidators();
      this.fg.controls["point"].setErrors(null);
      this.fg.controls["answer"].clearValidators();
      this.fg.controls["answer"].setErrors(null);
      this.optionFormGroup.controls["option"].clearValidators();
      this.optionFormGroup.controls["option"].setErrors(null);
      this.fg.updateValueAndValidity();
      
    }
  }
  contentTypeChange(e) {
    if (e == 3) {
      this.formGroup.controls["cource_content_english_video"].setValidators(Validators.required);
      this.formGroup.controls["course_content"].clearValidators();
      this.formGroup.controls["course_content"].setErrors(null);
      this.formGroup.updateValueAndValidity();
    } else {
      this.formGroup.controls["course_content"].setValidators(Validators.required);
      this.formGroup.controls["cource_content_english_video"].clearValidators();
      this.formGroup.controls["cource_content_english_video"].setErrors(null);
      this.formGroup.updateValueAndValidity();
      
    }
  }

  whitelistTypeChange(e){
    console.log(e);
    if(e.target.value == '2'){
      this.formGroup.get('zone_type').setValidators([Validators.required])
      this.formGroup.updateValueAndValidity();
    }else{
      this.formGroup.controls["zone_type"].clearValidators();
      this.formGroup.controls["zone_type"].setErrors(null);
    }
  }


  getRoleTypes(){
    this.apiService.get(this.apiConfig.configGetRoles).subscribe((res)=>{
      this.roleTypes = res['data'].filter(item => item.id == 5)
      console.log(this.roleTypes);
    })
  }
  
  getLanguage(){
    this.apiService.get(this.apiConfig.configGetLanguages)
    .subscribe((res:any)=>{
      this.languages = res.data
      console.log(this.languages);

    })
  }

  openModal(modal:any,field:string,questionIndex?:number,optionIndex?:number){
    this.modalTitle = field
    if(field=='question'){
      this.selectedQuestionIndex = questionIndex!
      console.log(this.selectedQuestionIndex);
    }
    if(field == "options"){
      this.selectedQuestionIndex = questionIndex!
      this.selectedOptionIndex = optionIndex!
    }
    this.modalService.open(modal, { size: 'xs', centered: true })
  }

  onModalDismiss(){
    this.getEnagagementDataOnEdit()
    console.log('Modal was dismissed in Parent Component!');
  }
  

  getEnagagementDataOnEdit() {
    this.apiService.get(this.apiConfig.viewEngagementDetail + `?engagement_page=3&engagement_type_id=${this.localData.engagement_type_id}&portfolio_id=${this.localData.protfolio_id}&task_id=${this.localData.task_id}`).subscribe((res: any) => {
      console.log(res)
      this.engagementDataOnEdit = res.data.engagement
      this.isUserwhitelisted = res.data.engagement.is_whitelisted

      if(this.isUserwhitelisted){
        this.formGroup.get('whitelist_type').disable()
        this.formGroup.get('role_type').disable()
      }
      setTimeout(() => {
        this.form(res.data.engagement)
      }, 100);
    })
  }

  getEngagementTypes() {
    this.apiService.get(this.apiConfig.engagementTypes + `?engagement_page=3`).subscribe((res: any) => {
      console.log(res)
      this.engagementTypes = res.data.engagementtypes;
    })
  }

  deleteQuestionAndOption(id,flag){

    let payload = {
      engagement_type : "7",
      engagement_task_id : "86",
      deletedQuestionId : flag == 1 ? id :null,
      deletedOptionsId : flag == 2 ? id : null
    }

    // this.apiService.post(this.apiConfig.deleteQuestionAndOption,payload)
    // .subscribe((res:any)=>{
    //   if(res.body.status == 200){
    //     this.toast.Success(res.body.data)
    //   }
    // })

  }

  onSubmit(formGroup) {
    let value = formGroup.getRawValue()
    console.log("submited called")
    this.submitted = true;
    console.log(this.formGroup);
    console.log(value);
    if (this.formGroup.invalid) {
        return this.toast.Warning('Select Required Feilds')
    }

    if(value.content_and_learning_type == 3){
      let regex = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)?([A-Za-z0-9_-]{11})(?:\?[^ ]*)?$/;
      let input = value.cource_content_english_video;
      let match = input.match(regex);
  
      if(!match){
        return this.toast.Warning("Invalid YouTube video link");
      }
    }

      let payload = {
      program_id: 1,
      portfolio_id: 1,
      engagement_id: value.engagement_type,
      engagement_title: value.engagement_name,
      start_date: moment(value.start_date).format("YYYY-MM-DD"),
      end_date: moment(value.end_date).format("YYYY-MM-DD"),
      course_type: value.content_and_learning_type,
      course_description: value.course_description,
      course_content: value.content_and_learning_type == 1 ? value.course_content : value.cource_content_english_video,
      quiz_configured: value.quiz_configured,
      quiz_points_criteria: value.reward_type ? value.reward_type : 3,
      reward_points: value.reward_points ? value.reward_points : null,
      pre_expiry_date: moment(value.pre_expiry_date).format("YYYY-MM-DD"),
      questions: value.quiz_configured == 1 ? value.questionsSet : [],
      task_id: this.engagementId,
      isEdit: (this.localData.is_edit || this.engagementId != "") ? 1 : 0,
      whitelist_type : value.whitelist_type,
      zone_type : this.f.zone_type.value,
      role_type : this.f.role_type.value,
      multilangData : this.engagementDataOnEdit ? this.engagementDataOnEdit.course_quiz : null,
    }
    this.apiService.post(this.apiConfig.createContentAndLarning, payload).subscribe((res: any) => {
    console.log(res)
    this.toast.Success("Engagement created Successfully") 
    let engagementDetail = {
      task_id: res.body.data.task_id,
      sub_tasks_id: res.body.data.sub_tasks_id,
      has_subtask: res.body.data.has_subtask,
      engagement_type_id: res.body.data.engagement_type_id,
      engagement_type: res.body.data.engagement_type,
      portfolio_id : value.portfolio,
      is_edit:true,
      whitelist_type : this.f.whitelist_type.value,
      zone_type : this.f.zone_type.value,
      role_type : this.f.role_type.value
    }
    localStorage.setItem("engagementDetail" , JSON.stringify(engagementDetail))
    this.engagementCreated.emit(true)
    this.getEngagementId.emit(res.body.data.task_id);
    this.getEngagementTypeId.emit(res.body.data.engagement_type_id)
    this.whitelist_obj.emit({wts_type : value.whitelist_type ,zn_type : value.zone_type})
  })
  }

  ngOnDestroy(): void {
  }

}
